import { httpClient } from '@texas/api/httpClient/httpClient';
import { CompositionGroup } from '../compositionGroup/compositionGroupApi';

export type ComponentType = 'single-entity' | 'count-entity';

export enum ComponentEntityType {
  Article = 1,
  ProductApproval = 2,
  CompositionGroup = 3,
  ArticleVariant = 4,
  ProductDevelopmentVariant = 5,
}

interface AiMessageSingleEntityComponent {
  entityId: number;
  type: ComponentEntityType;
  label: string;
  entityName: string;
}

export interface AiMessageArticleEntityComponent
  extends AiMessageSingleEntityComponent {
  pdVariantId: number | null;
  mainVariantId: number | null;
}

export interface AiMessageCompositionGroupEntityComponent
  extends AiMessageSingleEntityComponent {
  compositionGroup: CompositionGroup;
}

export interface AiMessageCountEntityComponent {
  entityIds: number[];
  blobData?: string;
  blobPreviewText?: string;
  type: ComponentEntityType;
  label: string;
}

export const componentsApi = {
  getSingleArticleEntityComponent: (componentId: number) =>
    httpClient.get<AiMessageArticleEntityComponent>(
      `/component/${componentId}/single/article`,
    ),
  getSingleCompositionGroupEntityComponent: (componentId: number) =>
    httpClient.get<AiMessageCompositionGroupEntityComponent>(
      `/component/${componentId}/single/composition-group`,
    ),
  getCountEntityComponent: (componentId: number) =>
    httpClient.get<AiMessageCountEntityComponent>(
      `/component/${componentId}/count`,
    ),
};
